import React, { HTMLAttributes, Component } from "react";
import * as PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import StudyBrowserSection from "../studyBrowserSection";

/**
 * 정의된 프로퍼티 없음. 기본 DIV Attribute는 전달
 *
 * @interface IHeaderProps    { Nothing }
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
// interface ISeriesListSectionProps extends HTMLAttributes<HTMLDivElement> {
//   seriesListStore: any;
// }

/**
 * Header Section UI Component
 *
 * @param {*} {}
 */
@inject("toolbarStore")
@observer
class SeriesListSection extends Component {
  // class SeriesListSection extends Component<ISeriesListSectionProps> {
  //   static propTypes: PropTypes.InferProps<ISeriesListSectionProps>;
  constructor(props) {
    super(props);
  }
  getSeriesBarVisibleClass = (isOpenSeriesList) => {
    if (isOpenSeriesList) {
      return "sidebar-open";
    } else {
      return "sidebar-close";
    }
  };
  render() {
    const { toolbarStore } = this.props;
    const isOpenSeriesList = toolbarStore.isOpenSeriesList();

    return (
      <div
        className={
          "sidebarMenu sidebar-left " +
          this.getSeriesBarVisibleClass(isOpenSeriesList)
        }
      >
        <div className="studyBrowser">
          <StudyBrowserSection />
        </div>
        <div className="clearfix"> </div>
      </div>
    );
  }
}

export default SeriesListSection;
